import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const ProductReviewNoItemWithFilter: React.FunctionComponent = () => {
    const { translate } = useTranslationHook();
    return (
        <div className="product-review-detail__no-item">
            <i className='icon icon-error icon-size-large' />
            <h2>{translate('Wow, you really like to filter!', { ns: 'article-list' })}</h2>
            <h3>{translate('Unfortunately, we currently have no reviews online for this filter combination.', { ns: 'article-list' })}</h3>
            <span>{translate('Just change your filter selection a little bit.', { ns: 'article-list' })}</span>
        </div>
    );
}

export default ProductReviewNoItemWithFilter;
